import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, HostListener, input, output, TemplateRef } from '@angular/core'
import { OnClickOutsideDirective } from '@ftr/foundation'
import { ActivePopoverStateService, PopoverState } from '../../services'
import { StaticMenuItem } from '../static-menu-item'
import { DropdownMenuItemsComponent } from './dropdown-menu-items/dropdown-menu-items.component'

/**
 * @deprecated Use the new DropdownMenu in foundation instead.
 */
@Component({
  imports: [CommonModule, DropdownMenuItemsComponent, OnClickOutsideDirective],
  selector: 'ftr-dropdown-menu-legacy',
  templateUrl: './dropdown-menu-legacy.component.html',
  styleUrls: ['./dropdown-menu-legacy.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuLegacyComponent implements PopoverState {
  ariaLabel = input('')
  openerTemplate = input.required<TemplateRef<any>>()
  menuItems = input.required<StaticMenuItem[]>()
  routerLinkActiveExact = input(true)
  isLeftPositioned = input(false)

  /**
   * In safari, some events are setting custom components as the target which
   * incorrectly trigger the `clickOutside` event. Use invalidTargetNames if you need to filter
   * out a list of specific components.
   */
  invalidTargetNames = input<string[]>()

  isOpen = output<boolean>()

  isShowing = computed(() => this.activePopoverStateService.activePopover() === this)

  constructor(private readonly activePopoverStateService: ActivePopoverStateService) {}

  toggle(): void {
    if (!this.isShowing()) {
      this.open()
    } else {
      this.close()
    }
  }

  open(_?: MouseEvent | FocusEvent | undefined): void {
    this.activePopoverStateService.activate(this)
    this.isOpen.emit(true)
  }

  close(_?: Event): void {
    this.activePopoverStateService.deactivate()
    this.isOpen.emit(false)
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleKeydown($event: KeyboardEvent): void {
    if (this.isShowing()) {
      this.close()
      $event.stopPropagation()
    }
  }

  @HostListener('keydown.Enter', ['$event'])
  toggleOnEnter($event: KeyboardEvent): void {
    this.toggle()
    $event.stopPropagation()
  }
}
